export default __webpack_public_path__ + "b3e390e23f037f4bfef4cfaf75bc8017.svg";